import {
  ADMIN_USER_ROLE,
  MANAGER_USER_ROLE,
  USER_STATUS_CODE_ACTIVE,
} from '../../../../constants/user'

const MOCK_ADMIN_USER = {
  avatar: null,
  avatar_color: '#C9DC98',
  fullname: 'Karola Egger',
  id: 8888881,
  role: ADMIN_USER_ROLE,
  status: USER_STATUS_CODE_ACTIVE,
}

const MOCK_MANAGER_USER = {
  avatar: null,
  avatar_color: '#DD9A80',
  fullname: 'John Sachs',
  id: 8888882,
  role: MANAGER_USER_ROLE,
  status: USER_STATUS_CODE_ACTIVE,
}

const CREATED_AT = '2023-01-12T10:00:00Z'
const UPDATED_AT = '2023-01-13T12:00:00Z'

export const PROFILE_CREATED_WIDGET_INHABITANT_VARIANTS = [
  {
    inhabitantData: {
      createdAt: CREATED_AT,
      createdBy: MOCK_ADMIN_USER,
      updatedAt: UPDATED_AT,
      updatedBy: MOCK_MANAGER_USER,
    },
    label: 'Created widget — created & updated',
  },
  {
    inhabitantData: {
      createdAt: CREATED_AT,
      createdBy: MOCK_ADMIN_USER,
    },
    label: 'Created widget — created only (no update)',
  },
  {
    inhabitantData: null,
    isSkeleton: true,
    label: 'Created widget — skeleton',
  },
]
